import { render } from "./home.vue?vue&type=template&id=7a908058"
const script = {}

import "./home.vue?vue&type=style&index=0&id=7a908058&lang=less"

import exportComponent from "/Users/xuesinuo/git/xsn_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__